<template>
  <div id="main-container">
    <app-header/>
    <div>
      <router-view class="view"></router-view>
    </div>
  </div>
</template>

<script>
  import appHeader from "../components/appHeader.vue";

  export default {
    components: {
      appHeader
    },
    computed: {
      user() {
        return this.$store.state.user.current;
      }
    },
    watch: {
      user: function (u) {
        if (u !== null && u.locale !== null) {
          this.$i18n.locale = u.locale;
          localStorage.setItem('locale', u.locale); // save
        }
      }
    },
    created() {
      // reset login status to get current user
      this.$store.dispatch('user/login');
    }
  }
</script>


<style lang="scss">
  @import '../style/global.scss';

  /* #main-container {
    min-height: 100vh;
    background-color: $light-grey;
  }  */

  body {
    background-color: $light-grey;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Main.vue